import { render, staticRenderFns } from "./NLPPage.vue?vue&type=template&id=2b798a2e&"
import script from "./NLPPage.vue?vue&type=script&lang=js&"
export * from "./NLPPage.vue?vue&type=script&lang=js&"
import style0 from "./NLPPage.vue?vue&type=style&index=0&id=2b798a2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports